module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1107.4f67fc2e.png";